export default __webpack_public_path__ + "static/landing-section-1-ac5e3cbedb3bc22781309c07bc024148.png";